var w_products = {

  variantSelector: 'input[name*="variant["]',
  messageSelector: 'input[name="variant[messageCategory]"]',
  bundleSelector: 'input[name*="bundle["]',
  bundleLineExampleSelector: '[data-bundle-total-lines-items-example]',
  bundleLinesContainer: '[data-bundle-lines-container]',
  bundleTotalLines: '[data-bundle-total-lines]',
  basePriceOutputSelector: '[data-base-price]',
  collapseSelector: '.collapse',
  complexBundleSelector: 'input[name*="bundleVariant"]',
  totalOutputSelector: '[data-total]',
  disableSelector: '[data-product-disable]',

  /**
   * Products init - intialise things that are required for products js
   */
  init: function() {
    var component = this;
    
    /**
     * Get prices straight away just incase there are some default options
     * selected
     */
    component.prices();

    // Enabled price updating
    if ( $( component.variantSelector ).length ) {
      $( component.variantSelector ).on( 'change', function( ev ) {
        component.prices();
      } );
    }

    // Enable custom text inputs
    if ( $( component.messageSelector ).length ) {
      $( component.messageSelector ).on( 'change', function( ev ) {
        customTextSelector = 'option-' + $( this ).val();
        component.customTextInputs( customTextSelector, $( this ), true );
      } );
    }

    // Enable custom text inputs for bundles
    if ( $( component.bundleSelector ).length ) {
      $( component.bundleSelector ).on( 'change', function( ev ) {
        component.prices();
        selector = 'bundle-' + $( this ).attr( 'name' ).replace( 'bundle[', '' ).replace( ']' , '' ) + '-' + $( this ).val();
        component.customTextInputs( selector, $( this ) );
      } );
    }
    
    // Enable Custom text inputs for complex bundle items
    if ( $( component.complexBundleSelector ).length ) {
      $( component.complexBundleSelector ).on( 'change', function( ev ) {
        component.prices();
      } );
      
      $( '[data-custom-text-selector]' ).on( 'change', function( ev ) {
        $( '[data-custom-text]' ).each( function( ) {
          selectorVal = $( this ).data( 'custom-text' ).replace( 'option-', '' );
          if ( $( '[data-custom-text-selector="' + selectorVal + '"]:checked' ).length ) {
            $( this ).removeClass( 'hidden' ).removeAttr( 'disabled', 'disabled' );
          } else {
            $( this ).addClass( 'hidden' ).attr( 'disabled', 'disabled' );
          }
        } );
      } );
    }
    
    // Enable activating/deactiving products in collapse bundle groups
    if ( $( component.collapseSelector ).length ) {
      // Enable when shown
      $( component.collapseSelector ).on( 'shown.bs.collapse', function( ev ) {
        $( this ).find( 'input[disabled="disabled"]' ).removeAttr( "disabled" );
      } );

      // Disable when hidden
      $( component.collapseSelector ).on( 'hidden.bs.collapse', function( ev ) {
        $( this ).find( 'input' ).attr( "disabled", "disabled" );
      } );
    }
  },

  /**
   * Custom Text Inputs - enable
   * TODO: Refactor to use new method as shown in custom text inputs for
   * complex bundle items above
   */
  customTextInputs: function( id, element, option ) {
    if ( ! option ) {
      option = false;
    }

    // Deal with radio changes
    if ( element.attr( 'type' ) == 'radio' ) {
      if ( $( '[data-custom-text="' + id + '"]').length ) {
        if ( ! option ) {
          otherRadios = id.substring(0, id.length - element.val().toString().length );
          $( '[data-custom-text*="' + otherRadios + '"]' ).addClass( 'hidden' ).attr( 'disabled', 'disabled' );
        }

        $( '[data-custom-text="' + id + '"]').removeClass( 'hidden' ).removeAttr( 'disabled' );
      } else {
        // Check to see if we are looking at bundle or variant selectors
        if ( option ) {
          $( '[data-custom-text*="option-"]' ).addClass( 'hidden' ).attr( 'disabled', 'disabled' );
        } else {
          otherRadios = id.substring(0, id.length - element.val().toString().length );
          $( '[data-custom-text*="' + otherRadios + '"]' ).addClass( 'hidden' ).attr( 'disabled', 'disabled' );
        }
      }
    } else if ( element.attr( 'type' ) == 'checkbox' ) {
      if ( $( '[data-custom-text="' + id + '"]').length ) {
        if ( element.is( ':checked' ) ) {
          $( '[data-custom-text="' + id + '"]').removeClass( 'hidden' ).removeAttr( 'disabled' );
        } else {
          $( '[data-custom-text="' + id + '"]' ).addClass( 'hidden' ).attr( 'disabled', 'disabled' );
        }
      }
    }
  },

  /**
   * Prices - An all encompassing function that handles the various parts of
   * calculating and display the pricing when the user takes an action
   */
  prices: function() {
    var component = this;
    component.setBasePrice();
    component.generateBundle();
  },

  /**
   * Generate Bundle - generates all the bundle text lines and calculate total
   * price
   */
  generateBundle: function() {
    var component = this;
    selectedBundles = component.getSelectedBundleItems();
    basePrice = $( component.basePriceOutputSelector ).data( 'base-price' );

    total = component.calculateTotal( basePrice, selectedBundles );
    component.setTotal( total );

    component.setBundleLines( selectedBundles );
  },

  /**
   * Set Bundle Lines on the total table
   */
  setBundleLines: function( selectedBundles ) {
    var component = this;
    hide = true;

    $( component.bundleLinesContainer + ' tr:not(' + component.bundleLineExampleSelector + ')' ).remove();

    if ( selectedBundles.length ) {
      for (var i = 0; i < selectedBundles.length; i++) {
        newLine = $( component.bundleLineExampleSelector )
          .clone() // Make a copy of the row
          .removeClass( 'hidden' ) // make sure it is visible
          .removeAttr( component.bundleLineExampleSelector.replace( '[', '' ).replace( ']', '' ) ) // remove non-required data tags
          .removeData( component.bundleLineExampleSelector.replace( '[', '' ).replace( ']', '' ) ); // remove non-required data tags

        // Replace appropriate data
        newLine.find( '[data-title]' ).text( selectedBundles[i].title );
        newLine.find( '[data-price]' ).html( '&dollar;' + parseFloat( selectedBundles[i].price ).toFixed( 2 ) );

        newLine.appendTo( component.bundleLinesContainer ); // Put new row in place
      }

      hide = false;
    }

    if ( hide ) {
      $( component.bundleTotalLines ).addClass( 'hidden' );
    } else {
      $( component.bundleTotalLines ).removeClass( 'hidden' );
    }

  },

  /**
   * Set Total on the html element in the front end
   */
  setTotal: function( total ) {
    var component = this;
    var totalElement = $( component.totalOutputSelector );
    if ( totalElement.length ) {
      totalElement.html( '&dollar;' + parseFloat( total ).toFixed( 2 ) );
    }
  },

  /**
   * Get Selected Bundle Items and create an array of title and price for output
   * usage
   * @return {Array}
   */
  getSelectedBundleItems: function() {
    var component = this;
    selectedBundles = [];
    $( component.bundleSelector + ':checked' ).each( function() {
      $this = $( this );
      if ( $this.data( 'title' ) && $this.data( 'price' ) ) {
        selectedBundles[ selectedBundles.length ] = {
          title: $this.data( 'title' ),
          price: $this.data( 'price' )
        };
      }

    } );

    // Deal with complex product selection within bundle groups
    if ( $( component.complexBundleSelector + ':not(:disabled):checked' ).length ) {
      var complexSelected = {};
      $( component.complexBundleSelector + ':not(:disabled):checked' ).each( function() {
        
        regMatch = $(this).attr( 'name' ).match(/bundleVariant\[\d+\]\[(\d+)\]/);
        if ( regMatch.length ) {
          productId = regMatch[ 1 ];
          
          if ( !complexSelected[ productId ] ) {
            complexSelected[ productId ] = [];
          }
          complexSelected[ productId ].push( $( this ).val() );
        }
        
      } );
      
      if ( complexSelected ) {
        $.each( complexSelected, function( productId, variantIds ) {
                    
          if ( window[ 'bundleVariantPrices' + productId ] && window[ 'bundleVariantPrices' + productId ][ variantIds.join( '-' ) ] ) {
            selVariant = window[ 'bundleVariantPrices' + productId ][ variantIds.join( '-' ) ];
            
            realPrice = selVariant.price;
            if ( selVariant.onSale ) {
              realPrice = selVariant.salePrice;
            }
            
            selectedBundles[ selectedBundles.length ] = {
              title: selVariant.title,
              price: realPrice
            }
          }

        } );
      }
    }

    return selectedBundles;
  },

  /**
   * Calculate Total of product(s) to get shown in the front end
   */
  calculateTotal: function( basePrice, selectedBundles ) {
    total = parseFloat( basePrice );

    if ( selectedBundles.length ) {
      for (var i = 0; i < selectedBundles.length; i++) {
        total += parseFloat( selectedBundles[i].price );
      }
    }

    return total;
  },

  /**
   * Set Base Price on the front end element
   */
  setBasePrice: function() {
    var component = this;
    selectedIds = $( component.variantSelector + ':checked' ).serializeArray();
    idString = component.createIdString( selectedIds );

    if ( idString ) {
      price = component.getBasePrice( idString );
      component.enableProduct();

      if ( price ) {
        priceOutput = price.priceText;
        priceData = price.price;
        if ( priceOutput.onSale ) {
          priceOutput = price.salePriceText;
          priceData = price.salePrice;
        }
        $( component.basePriceOutputSelector ).text( priceOutput );
        $( component.basePriceOutputSelector ).data( 'base-price', priceData ).attr( 'data-base-price', priceData );
      } else {
        component.disableProduct();
      }
    }
  },

  /**
   * Enable all appropriate fieldsets and hide any alerts that maybe shown
   */
  enableProduct: function() {
    var component = this;

    // Show Alert message
    var alertMsg = $( 'div' + component.disableSelector + '.alert' );
    if ( alertMsg.length ) {
      alertMsg.addClass( 'hidden' );
    }

    // Enable all the fieldsets
    var fieldset = $( 'fieldset' + component.disableSelector );
    if ( fieldset.length ) {
      fieldset.removeClass( 'muted' ).removeAttr( 'disabled' );
    }
  },

  /**
   * Disable fieldsets and show alert it variant combination is not allowed
   */
  disableProduct: function() {
    var component = this;

    // Show Alert message
    var alertMsg = $( 'div' + component.disableSelector + '.alert' );
    if ( alertMsg.length ) {
      alertMsg.removeClass( 'hidden' );
    }

    // Enable all the fieldsets
    var fieldset = $( 'fieldset' + component.disableSelector );
    if ( fieldset.length ) {
      fieldset.addClass( 'muted' ).attr( 'disabled', 'disabled' );
    }
  },

  /**
   * Created ID String for selecting the correct price
   * @param  {Array} selectedIds
   * @return {String}
   */
  createIdString: function( selectedIds ) {
    var component = this;
    idString = '';
    if ( selectedIds ) {
      ids = [];
      for (var i = 0; i < selectedIds.length; i++) {
        ids.push( selectedIds[i].value );
      }

      idString = 'v-' + ids.join( '-' );
    }

    return idString;
  },

  /**
   * Get Base Price from predefined array
   * @param  {String} idString
   * @return {Int}
   */
  getBasePrice: function( idString ) {
    price = false;

    if ( idString && variantPrices != undefined && Object.keys( variantPrices ).length && variantPrices[ idString ] ) {
      price = variantPrices[ idString ];
    }

    return price;
  }

};
